<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest} width={204} height={18} viewBox="0 0 204 18">
	<path
		d="M33.6096 4.02288V1.00607H23.9905V17.0059H33.7224V13.9886H27.0918V10.4H33.0481V7.42866H27.0918V4.02288H33.6096Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M3.10168 7.36018V1.00586H0V17.0057H3.10168V10.3774H8.94536V17.0057H12.0247V1.00586H8.94536V7.36018H3.10168Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M53.9694 10.766L47.2265 1.00586H44.8666V17.0057H47.9682V7.22322L54.7111 17.0057H57.0711V1.00586H53.9694V10.766Z"
		fill={getTailwindColor(color)}
	/>
	<path d="M72 17.0057V1.00586H68.8987V17.0057H72Z" fill={getTailwindColor(color)} />
	<path
		d="M88.0233 16.9961V10.6647H91.909C93.3262 10.6647 94.4919 10.2075 95.4062 9.31609C96.3433 8.40181 96.8004 7.23609 96.8004 5.79609C96.8004 4.35609 96.3433 3.19038 95.4519 2.32181C94.5604 1.43038 93.3719 0.996094 91.909 0.996094H86.1719V16.9961H88.0233ZM88.0233 2.64181H91.749C93.669 2.64181 94.9033 3.94466 94.9033 5.79609C94.9033 7.64752 93.6462 9.01895 91.749 9.01895H88.0233V2.64181Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M105.364 16.9961V10.5275H108.861L112.404 16.9961H114.552L110.804 10.3447C111.741 10.0704 112.541 9.52181 113.181 8.67609C113.821 7.83038 114.141 6.84752 114.141 5.72752C114.141 2.87038 112.152 0.996094 108.929 0.996094H103.512V16.9961H105.364ZM105.364 2.64181H108.815C110.987 2.64181 112.221 3.92181 112.221 5.72752C112.221 7.73895 110.872 8.88181 108.929 8.88181H105.364V2.64181Z"
		fill={getTailwindColor(color)}
	/>
	<path d="M123.217 16.9961V0.996094H121.366V16.9961H123.217Z" fill={getTailwindColor(color)} />
	<path
		d="M133.079 16.9961V5.06467H133.216L138.541 16.9961H140.644L145.513 5.06467H145.65V16.9961H147.433V0.996094H145.399L139.661 14.9618H139.524L133.33 0.996094H131.296V16.9961H133.079Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M155.625 16.9961L157.065 13.2018H164.791L166.231 16.9961H168.174L162.025 0.996094H159.854L153.682 16.9961H155.625ZM160.86 3.14467H160.997L164.151 11.5104H157.705L160.86 3.14467Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M176.265 16.9961V10.5275H179.763L183.305 16.9961H185.454L181.705 10.3447C182.643 10.0704 183.443 9.52181 184.083 8.67609C184.723 7.83038 185.043 6.84752 185.043 5.72752C185.043 2.87038 183.054 0.996094 179.831 0.996094H174.414V16.9961H176.265ZM176.265 2.64181H179.717C181.888 2.64181 183.123 3.92181 183.123 5.72752C183.123 7.73895 181.774 8.88181 179.831 8.88181H176.265V2.64181Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M195.33 10.8475V16.9961H197.204V10.8475L203.033 0.996094H200.93L196.313 8.95038H196.176L191.513 0.996094H189.502L195.33 10.8475Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
